import { xCrossCorrelation } from './xCrossCorrelation';
/**
 * Calculates the auto-correlation of a vector
 *
 * @param A - the array that will be fixed
 * @param options - Options
 */
export function xAutoCorrelation(A, options = {}) {
    return xCrossCorrelation(A, A, options);
}
//# sourceMappingURL=xAutoCorrelation.js.map